import type { ScanOutcome } from './cart';

/** Woher ein Code kommt: Kamera (Dauerscan, sieht auch Beiwerk) oder Eingabe (Tastatur, Handscanner). */
export type ScanSource = 'camera' | 'manual';

/**
 * Arbeitet Scans strikt nacheinander ab (Dauerscan): Zwei Codes aus demselben Kamerabild laufen sonst gleichzeitig durch
 * `store.findByCode` und sehen beide den alten Warenkorb. Ein fehlgeschlagener Auftrag hält die Warteschlange nicht an.
 */
export class ScanQueue {
  private tail: Promise<void> = Promise.resolve();
  private waiting = 0;

  /** Reiht den Auftrag ein; die Rückgabe ist erfüllt, sobald er (und alle davor) durch sind. */
  push(task: () => Promise<void>): Promise<void> {
    this.waiting += 1;
    const run = this.tail.then(task).then(
      () => undefined,
      () => undefined,
    );
    this.tail = run.finally(() => {
      this.waiting -= 1;
    });
    return this.tail;
  }

  /** Anzahl der noch nicht fertigen Aufträge. */
  get size(): number {
    return this.waiting;
  }
}

/**
 * Im Kameramodus bleibt „liegt schon im Warenkorb“ still: Das Etikett wird oft ein zweites Mal vorgehalten, ein Fehlerton
 * wäre dort nur Lärm. Eine falsche Prüfziffer oder Form bleibt ein hörbarer Fehler, ebenso jede Eingabe per Tastatur.
 */
export function isQuietRepeat(outcome: ScanOutcome, source: ScanSource): boolean {
  return source === 'camera' && outcome.kind === 'rejected' && outcome.reason === 'in_cart';
}
